import axios from 'axios';
import { error as eMessage } from '../assecs/json';

import { resetState } from '../store/pages/loginSlice';
import { setMessage } from '../store/components/alertSlice';
import { showSpinner } from '../store/components/spinnerSlice';

const baseURL = process.env.REACT_APP_BASE_URL;

axios.defaults.timeout = 300000;
axios.defaults.baseURL = baseURL;
axios.defaults.headers = { 'Content-Type': 'application/json' };

const Interceptor = (store) => {
    axios.interceptors.request.use(
        request => {
            const token = localStorage.getItem('authorization');
            const checkLists = ['/manage/common/key', '/manage/oth/faq/category', '/manage/sys/role'];

            if (token)
                request.headers.Authorization = `Bearer ${token}`;
            
            if (!checkLists.includes(request.url))
                store.dispatch(showSpinner(true));
            
            return request;
        },
        error => {console.log('Request', error);
            store.dispatch(showSpinner(false));
        }
    );
    
    axios.interceptors.response.use(
        response => {
            const {data, status, config: { responseType }, data: { code, message, result }} = response;
            const _message = { message: message || eMessage[code] };
            const dispatch = setMessage(_message);
            
            setTimeout(() => store.dispatch(showSpinner(false)), 500);
            
            if (code === 1000 && message === 'success')
                return result;
            else if (status === 200 && responseType === 'blob')
                return data;
            
            store.dispatch(dispatch);
            return Promise.reject(data);
        },
        error => {console.log('Response', error);
            const { response: { status, data } } = error;
            const _message = { message: data.message || eMessage[status] };
            const dispatch = setMessage(_message);
            
            store.dispatch(dispatch);
            store.dispatch(showSpinner(false));
            
            if (status === 401)
                setTimeout(() =>  store.dispatch(resetState()), 500);
            else if (status === 400 || data.code === -2003 || data.code === -3004)
                return data;

            return Promise.reject(data);
        }
    )
};

export default Interceptor;